import classNames from "classnames";
import { ReactNode } from "react";

import { useMenuContext } from "./MenuContext";

export type MenuItemsProps = {
  className?: string;
  children: ReactNode;
};

const MenuItems = ({ className, children }: MenuItemsProps) => {
  const { open, menuRef } = useMenuContext();

  return (
    <div
      ref={menuRef}
      className={classNames("Menu__items", className)}
      role="menu"
      aria-hidden={!open}
      data-state={open ? "open" : "closed"}
    >
      {children}
    </div>
  );
};

export default MenuItems;
